export const convertFullWidthToHalfWidth = (value: string): string => {
  // return value
  //   .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
  //   .replace(/[－]/g, '-')
  //   .replace(/[ー]/g, '-')
  return value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
}

export const formatCurrency = (value: string | number): string => {
  if (!value) return '';

  const convertedValue = convertFullWidthToHalfWidth(String(value));

  const numericValue = convertedValue.replace(/[^\d]/g, '');

  if (!numericValue) return '';

  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const unformatCurrency = (value: string): string => {
  if (!value) return '';

  const convertedValue = convertFullWidthToHalfWidth(value);

  return convertedValue.replace(/[^\d]/g, '');
};

export const formatPostalCode = (value: string): string => {
  const numbers = value.replace(/[^\d\-]/g, '')

  if (!numbers.replace(/-/g, '')) {
    return ''
  }

  const digits = numbers.replace(/-/g, '')

  const limitedDigits = digits.slice(0, 7)

  if (limitedDigits.length <= 3) {
    return limitedDigits
  }

  return limitedDigits.slice(0, 3) + '-' + limitedDigits.slice(3, 7)
}

export const formatPhoneNumber = (value: string): string => {
  const numbers = value.replace(/[^\d]/g, '')

  if (!numbers) return ''

  const limitedDigits = numbers.slice(0, 11)

  if (limitedDigits.length <= 3) {
    return limitedDigits
  } else if (limitedDigits.length <= 7) {
    return `${limitedDigits.slice(0, 3)}-${limitedDigits.slice(3)}`
  } else {
    return `${limitedDigits.slice(0, 3)}-${limitedDigits.slice(3, 7)}-${limitedDigits.slice(7, 11)}`
  }
}

export const formatSubDomain = (value: string): string => {
  return value.replace(/[^a-zA-Z0-9\-]/g, '');
}